module.exports = __webpack_public_path__ + "static/media/turnovers.cf1de480.JPG";